import getWindow from "./getWindow.js";
export default function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}


//////////////////
// WEBPACK FOOTER
// /home/apa/domains/apa.plug-in.es/public_html/wp-content/themes/templatePLG/node_modules/@popperjs/core/lib/dom-utils/getWindowScroll.js
// module id = 26
// module chunks = 0